module.exports = __webpack_public_path__ + "media/img/illustrations/esr-warning-083a429671a4fc798b98e83e05276107.svg";